import './EnhancedLineChart.css';
import { LineChart, d3 } from 'react-d3-components';
import { t } from 'i18next';
import React from 'react';
import { connect } from 'react-redux';
import ColorDetails from '../colorDetails/ColorDetails';
import { stringToNumberLocale } from '../../../helpers/formatter';
import ChartReport from '../ChartReport';
import ReportsDescription from '../reportsDescription/ReportsDescription';


const maxTicksLength = 16;
class EnhancedLineChart extends ChartReport {
  render() {
    const {
      title, width, height, data, xLabel, yLabel, formatter = f => f, inputRequired, helperMsg = '', description = null,
    } = this.props;
    const xscaleDomain = ! data || ! data.length
      ? [] : data[0].values.map(({ x }) => x);
    const xscaleRange = ! data || ! data.length
      ? [] : data[0].values.map((_, i) => i * (width - (width * 0.1)) / xscaleDomain.length);
    const xscale = d3.scale.ordinal().domain(xscaleDomain).range(xscaleRange);
    xscale.invert = x => xscale.domain()[d3.bisect(xscale.range(), x)];
    const scale = d3.scale.ordinal().range(['#1f77b4', 'grey']);
    // const scale = ['#4A90E2', '#DA3B6C', 'grey'].concat(d3.scale.category20().range().slice(0).splice(0, 3));
    const descExpanded = description ? description.isExpanded : false;

    const dashLine = function (label) {
      if (label === 'Available Transaction') {
        return '4 4 4';
      }
      return null;
    };


    return (
      <div id={title}
        className="EnhancedLineChart report"
        style={{
          width,
        }}
      >
        <ReportsDescription title={t(title)}
          description={description}
          width={width - (width * 0.05)}
        />
        <br />

        { inputRequired ? this.helperMsg(width, height, helperMsg, this.isDescExpanded())
          : (
            <span>
              {! data

                ? ChartReport.chartStatus(width, height)

                : (
                  <LineChart width={width}
                    height={height}
                    /** there must be at least two entries to render line chart */
                    data={data.length && data[0].values.length && data[0].values.length > 1
                      ? data : {
                        label: '',
                        values: [{
                          x: '',
                          y: 0,
                        }],
                      }}
                    tooltipHtml={data.length && data[0].values.length && data[0].values.length > 1
                      ? (_, { x, y }) => `${x}: ${stringToNumberLocale(formatter(y))}` : undefined}
                    xAxis={ChartReport.xAxis(xLabel)}
                    yAxis={ChartReport.yAxis(yLabel)}
                    xScale={data.length && data[0].values.length && data[0].values.length > 1
                      ? xscale : undefined}
                    margin={ChartReport.chartMargin()}
                    colorScale={scale}
                    stroke={{
                      strokeDasharray: dashLine,
                    }}
                  />
                )
              }

              {ChartReport.tooltipContainer(title)}

              {! descExpanded && data && data.length !== undefined
              && (data.length === 0 || data[0].values.length < 1)
                ? <span className="noData">{t('N/A')}</span> : ''}

              {! descExpanded && data && data.length && data[0].values.length === 1
                ? <span className="noData">{t('notEnoughData')}</span> : ''}

              {! data || data.length < 2 || ! data.map || ! data[0].values.length ? null
                : (
                  <ColorDetails data={data.map(({ label, values }, index) => ({
                    color: scale.range()[index],
                    label,
                    values,
                  }))} filterByPercentage={false}
                  />
                )
              }
            </span>
          )
        }
      </div>
    );
  }

  componentDidUpdate() {
    const { title } = this.props;
    // get x axis tick textSVG array
    // replace with empty string till skip values
    const textSVGs = document.getElementById(title).querySelectorAll('.x.axis .tick text');

    if (textSVGs.length > maxTicksLength) {
      // calculate values to skip
      const skipValues = (Math.ceil(textSVGs.length / maxTicksLength));
      textSVGs.forEach((textSVG, i) => {
        // eslint-disable-next-line no-param-reassign
        if ((i !== textSVGs.length - 1) && (i % skipValues !== 0)) textSVG.innerHTML = '';
      });
    }
    this.generateTooltips();
  }
}

export default connect()(EnhancedLineChart);
